// Service Worker registration + install prompt helper
let deferredPrompt = null;
const listeners = [];

export function registerSW() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // KILL-SWITCH MODE: unregister qualsiasi vecchio SW senza riregistrare nulla di nuovo.
  // Questo elimina i bug da bundle JS cached su device reali (es. login mobile).
  // Una volta stabilizzato, potremo reintrodurre un SW piu' robusto.
  window.addEventListener("load", async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      if (regs.length > 0) {
        // eslint-disable-next-line no-console
        console.log(`[PWA] Unregistering ${regs.length} old service worker(s)...`);
        // Trigger update una volta per garantire che il SW kill-switch v3 venga servito
        await Promise.all(regs.map(async (reg) => {
          try { await reg.update(); } catch {}
        }));
        // Aspetta brevemente per dare tempo al kill-switch di girare (unregister self)
        setTimeout(async () => {
          try {
            const remaining = await navigator.serviceWorker.getRegistrations();
            await Promise.all(remaining.map((r) => r.unregister()));
          } catch {}
        }, 2000);
      }
      // Svuota anche le cache storage (old SW cached bundle)
      if ("caches" in window) {
        const keys = await caches.keys();
        if (keys.length > 0) {
          await Promise.all(keys.map((k) => caches.delete(k)));
        }
      }
    } catch {}
  });

  // Cattura install prompt per riusare in seguito (install PWA nativa tramite manifest)
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((cb) => cb(true));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((cb) => cb(false));
  });
}

export function canInstall() {
  return !!deferredPrompt;
}

export async function promptInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((cb) => cb(false));
  return choice?.outcome === "accepted";
}

export function onInstallabilityChange(cb) {
  listeners.push(cb);
  return () => {
    const idx = listeners.indexOf(cb);
    if (idx >= 0) listeners.splice(idx, 1);
  };
}

/** True se l'app sta girando come PWA installata (standalone). */
export function isStandalone() {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(display-mode: standalone)")?.matches
    || window.navigator.standalone === true;
}
